<template>
  <div>
<!--    <vue-editor :value="value" @input="$emit('input', $event)"></vue-editor>-->
    <wysiwyg-editor :value="value" @input="$emit('input', $event)"></wysiwyg-editor>
  </div>
</template>

<script>
import WysiwygEditor from '../WysiwygEditor'
export default {
  name: 'CourseBuilderTextBlock',
  components: { WysiwygEditor },
  props: ['value']
};
</script>

<style scoped>

</style>